import { render } from "./OPINION_ARCHIVED_MADE_PUBLIC.vue?vue&type=template&id=09b750f4"
import script from "./OPINION_ARCHIVED_MADE_PUBLIC.vue?vue&type=script&lang=js"
export * from "./OPINION_ARCHIVED_MADE_PUBLIC.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__